(function () {
  const hero = document.querySelector('[data-nutra-hero]');
  if (!hero) return;

  const slides = hero.querySelectorAll('[data-nutra-hero-slide]');
  const dots = hero.querySelectorAll('[data-nutra-hero-dot]');
  if (slides.length === 0) return;

  let current = 0;

  function goTo(index) {
    slides[current].classList.remove('is-active');
    if (dots[current]) dots[current].classList.remove('is-active');
    current = index;
    slides[current].classList.add('is-active');
    if (dots[current]) dots[current].classList.add('is-active');
  }

  setInterval(function () {
    goTo((current + 1) % slides.length);
  }, 4000);
})();
